const englishUS = {
  'homepage.welcome': 'Welcome To The Webshop',
  'webshopclose.timePrefix': 'You have',
  'webshopclose.timeSuffix': 'to submit your request for orders.',
  'webshopclose.closed': 'The webshop is currently closed.',
  'announcement.announcementLabel': 'Announcements',
  'announcement.readMore': 'Read More',
  'announcement.readAck':
    'By proceeding, you are acknowledging that you have read all announcements',
  'announcement.proceedLabel': 'proceed',
  'announcement.showPrevMessages': 'Show previous messages',
  'announcement.important': 'new important messages',
  'announcement.view': 'View',
  dealerInventory: 'Dealer Inventory',
  processingCenter: 'Processing Center',
  inTransitToVPC: 'In Transit to VPC',
  scheduledInProduction: 'Scheduled/In Production',
  producedNotShipped: 'Produced/Not Shipped',
  onOrder: 'On Order',
  allocation: 'Allocation',
  unsubmitted: 'Unsubmitted Quota',
  projectedPipeline: 'Projected Pipeline',
  quota: 'Quota',
  'pipelineDropdown.currentStatus': 'Current Submission Status',
  recentHistoryFootnote: 'Recent history may not be reflected in the pipeline',
  quantity: 'quantity',
  submitted: 'Submitted',
  remaining: 'Remaining',
  'summary.inCartLabel': 'In Cart',
  'summary.basePriceLabel': 'base price',
  'summary.unitsLabel': 'units',
  'navigation.orderDashboard': 'order dashboard',
  'sidenav.orderNav': 'Dashboard',
  'sidenav.analyticsNav': 'Analytics',
  'sidenav.bmwWsBrand': 'BMW Webshop',
  'sidenav.miniWsBrand': 'MINI Webshop',
  priceBandAbbrv: 'PB',
  quantityAbbrv: 'Qty',
  series: 'series',
  currency: 'USD',
  addedToReview: 'Added to Review',
  units: 'units',
  unit: 'unit',
  'template.designPackage': 'Design Combination',
  'template.designPrice': 'Design Price',
  'model.priceBand': 'Price Band',
  'template.totalPrice': 'Total Price',
  'template.suggested': 'Suggested',
  'template.priority': 'P',
  'template.priorityHeader': 'Priority',
  optionCluster: 'Option Cluster',
  templateOverview: 'template overview',
  exteriorName: 'Exterior',
  wheelName: 'Wheel',
  interiorName: 'Interior',
  trimName: 'Trim',
  capsName: 'Caps',
  colorLineName: 'Color Line',
  increasePrice: 'Price will increase by',
  decreasePrice: 'Price will decrease by',
  changePriceBand: 'Price band will change to',
  addToCart: 'Add to cart',
  addAllToCart: 'Add All to Cart',
  locked: 'Locked',
  expandPrioritiesLabel: 'Expand priorities',
  collapsePrioritiesLabel: 'Collapse priorities',
  multipleOption: 'Multiple',
  review: 'Review',
  noSubmittedTemplates:
    'No templates have been submitted for this option cluster',
  noInReviewTemplates:
    'No template suggestions for this functional group, search within the group to see all the available',
  submittedNotifcationStart: 'You have already submitted',
  submittedNotifcationEnd: 'for this configuration',
  detail: 'Detail',
  remove: 'Remove',
  close: 'Close',
  duplicate: 'Duplicate',
  notApplicable: 'n/a',
  posted: 'posted',
  back: 'Back',
  checkout: 'Checkout',
  checkoutProcess: 'All units will be processed for',
  submitOrder: 'Submit Order',
  model: 'Model',
  quantityCapital: 'Quantity',
  cartSeries: 'SERIES',
  totalSelected: 'Total Selected',
  selectAll: 'Select All',
  backToDashboard: 'Back to Dashboard',
  requestSubmitted: 'Request submitted for',
  darUpdate:
    'Your DAR should be updated with your submitted request in the next 24hrs',
  searchPlaceholder: 'Search by name or design code',
  'chartLabel.comparison': 'Comparison',
  'chartLabel.pipeline': 'Pipeline',
  'chartLabel.competition': 'Competition',
  'chartLabel.advanced': 'Advanced',
  'chartLabel.comparisonDescription': 'SUGGESTED VS. SELECTED COMPARISON CHART',
  'chartLabel.pipelineDescription': 'PIPELINE AND PRICE BAND COMPARISON',
  'chartLabel.advancedDescription': 'ADVANCED PIPELINE ANALYSIS',
  'chartLabel.competitionDescription': 'COMPETITIVE LANDSCAPE',
  'comparisonChart.selectedTemplates': 'Selected Templates',
  'comparisonChart.suggestedTemplates': 'Suggested Templates',
  'advancedChart.presold': 'Presold Customer Order',
  'advancedChart.stock': 'Stock Order',
  'competitionChart.selectedTemplates': 'Selected Templates',
  'competitionChart.competitorDistribution': 'Competitor Distribution',
  edit: 'Edit',
  clearFilters: 'Clear Filters',
  findMore: 'Find',
  functionalGroup: 'Functional Group',
  settingTitle: 'Settings',
  saveText: 'Save',
  settings: 'Settings',
  helpCenter: 'Help Center',
  cartUpdateMessage:
    'Your cart has been modified by another user. Please proceed to see the most recent updates.',
  confirmationMessage: 'Proceed',
  total: 'TOTAL',
  submissionFailure: 'Your order was not submitted. Please try again.',
  pbAbbreviation: 'PB',
  loading: 'LOADING...',
  noTemplates: 'There are currently no templates associated with this model.',
  submitting: 'Submitting...',
  settingUpdatedText: 'Your user settings have been updated.',
  helpCenterTitle: 'Help Center',
  'designOptionFilters.exteriorPlaceHolder': 'Search by exterior code or name',
  'designOptionFilters.interiorPlaceHolder': 'Search by interior code or name',
  'designOptionFilters.wheelPlaceHolder': 'Search by wheel code or name',
  'designOptionFilters.trimPlaceHolder': 'Search by trim code or name',
  'designOptionFilters.roofAndMirrorCapsPlaceHolder':
    'Search by roof and mirror caps code or name',
  'designOptionFilters.colorLinesPlaceHolder':
    'Search by color lines code or name',
  'designOptionFilters.exteriorHeader': 'EXTERIOR',
  'designOptionFilters.interiorHeader': 'INTERIOR',
  'designOptionFilters.trimHeader': 'TRIM',
  'designOptionFilters.wheelHeader': 'WHEELS',
  'designOptionFilters.roofAndMirrorCapsHeader': 'ROOF AND MIRROR CAPS',
  'designOptionFilters.colorLinesHeader': 'COLOR LINES',
  'designOptionFilters.clear': 'Clear all filters',
  'designOptionFilters.filter': 'Filter within group',
  'designOptionFilters.search': 'Search within group',
  'designOptionFilters.clearFiltersButton': 'Clear And Continue',
  'designOptionFilters.cancelButton': 'Cancel',
  'designOptionFilters.clearFiltersTitle': 'Clear all filters within a group?',
  'designOptionFilters.clearFiltersMessage':
    'Performing a global search or applying any changes to it, will result in clearing all filters applied within functional groups. Are you sure you want to continue?',
  'designOptionFilters.clearGlobalFiltersMessage':
    'Searching within a group will result in clearing all filters applied to the global search. Are you sure you want to continue?',
  'designOptionFilters.clearGlobalFiltersTitle': 'Clear all global filters?',
  noSearchResultsNotice: 'No templates match the chosen search criteria',
};

export default {
  'en-us': englishUS,
};
